import React from "react";
import {
  Scale,
  BookOpen,
  ShieldCheck,
  Users,
  HeartHandshake,
  Gavel,
} from "lucide-react";

const services = [
  {
    icon: Scale,
    title: "Legal Awareness Programs",
    description:
      "Conducting awareness campaigns to educate citizens about their legal rights and responsibilities.",
  },
  {
    icon: Gavel,
    title: "Legal Consultation Support",
    description:
      "Providing guidance and support to individuals seeking legal assistance and information.",
  },
  {
    icon: ShieldCheck,
    title: "Consumer Rights Assistance",
    description:
      "Helping consumers understand and protect their rights against unfair practices.",
  },
  {
    icon: Users,
    title: "Women's Rights Support",
    description:
      "Creating awareness and support systems for women's legal rights and empowerment.",
  },
  {
    icon: BookOpen,
    title: "Youth Legal Education",
    description:
      "Educational programs designed to help students and young professionals understand legal frameworks.",
  },
  {
    icon: HeartHandshake,
    title: "Community Welfare Activities",
    description:
      "Organizing social welfare initiatives and community development programs.",
  },
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white text-black">
      <div className="max-w-7xl mx-auto px-8">
        
        {/* Heading */}
        <div className="text-center mb-20">
          {/* Eyebrow */}
          <div className="mb-6 border-t border-b border-black py-4 inline-block">
            <span className="text-xs font-sans tracking-widest uppercase font-light">
              Our Services
            </span>
          </div>

          {/* Main Heading */}
          <h2 className="text-6xl md:text-7xl font-black mt-6 mb-6" style={{fontFamily: 'Georgia, serif'}}>
            What We Do
          </h2>

          {/* Divider Line */}
          <div className="w-32 h-1 bg-black mx-auto mt-8 mb-8"></div>

          <p className="max-w-3xl mx-auto text-lg md:text-xl font-sans font-light text-gray-700 leading-relaxed">
            We are committed to promoting legal awareness, social welfare, and community empowerment through various educational and support initiatives.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <div
                key={index}
                className="group border-2 border-black p-8 hover:bg-black hover:text-white transition duration-300"
              >
                {/* Icon Box */}
                <div className="w-16 h-16 border-2 border-black flex items-center justify-center mb-6 group-hover:bg-white group-hover:border-white transition">
                  <Icon
                    size={32}
                    strokeWidth={1.5}
                    className="group-hover:text-black"
                  />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-black mb-4" style={{fontFamily: 'Georgia, serif'}}>
                  {service.title}
                </h3>

                {/* Description */}
                <p className="font-sans font-light text-base leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Learn More Button */}
                <button className="text-sm font-sans font-bold uppercase tracking-wide hover:translate-x-1 transition flex items-center gap-2">
                  Learn More
                  <span>→</span>
                </button>
              </div>
            );
          })}
        </div>

        {/* Divider */}
        <div className="h-px bg-black my-16"></div>

        {/* CTA Section */}
        <div className="bg-black text-white p-12 md:p-16">
          <h3 className="text-5xl md:text-6xl font-black text-center mb-6" style={{fontFamily: 'Georgia, serif'}}>
            Need Legal Guidance?
          </h3>

          {/* Divider */}
          <div className="w-32 h-1 bg-white mx-auto my-8"></div>

          <p className="text-lg md:text-xl font-sans font-light text-gray-300 text-center max-w-3xl mx-auto mb-10">
            Connect with Legal Lions People Association and learn more about your rights, legal awareness programs, and community initiatives.
          </p>

          <div className="flex justify-center">
            <button className="bg-white text-black px-10 py-4 font-sans font-bold text-sm hover:bg-gray-200 transition flex items-center gap-2 group uppercase tracking-wide">
              Contact Us Today
              <span className="group-hover:translate-x-1 transition">→</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;